import { IRootState } from 'redux/reducer';

export const selectFloorplan = (rootState: IRootState): object | undefined => {
  return rootState.floorspace.floorplan;
};

export const selectFloorplanIsJustSaved = (rootState: IRootState): boolean => {
  return rootState.floorspace.isJustSaved;
};
